import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { Tweens } from "../Components/Effects/Tweens";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";
import { PlayList } from "../Components/Sounds/PlayList";

@engineComponent(ComponentTypes.DisplayObject)
export class Mystery extends ContainerElement {
    public static MultiplierIndex: number = 0;

    private indexArray: Array<number> = [];

    private _timerStatus: number = 0;
    private _timer: FrameTimerEventEmitter;

    constructor() {
        super();

        this._timer = CreateFrameTimer("timer");
        this._timer.on(FrameTimerEvents.Complete, this.onTimer.bind(this));
    }

    public updateByNode(node: Element): void {
        super.updateByNode(node);

        if (node.hasAttribute("Action")) {
            switch (node.getAttribute("Action")) {
                case "start":
                    this.start();
                    break;
                case "restart":
                    this.restart();
                    break;
            }
        }
    }

    private getRandom(min: number, max: number): number {
        return Math.random() * (max - min) + min;
    }

    private onTimer(): void {
        switch (this._timerStatus) {
            case 1:
                this.wawe1();
                break;
            case 2:
                this.wawe2();
                break;
            case 3:
                this.wawe3();
                break;
            case 4:
                this.wawe4();
                break;
            case 5:
                this.wawe5();
                break;
            case 6:
                this.final();
                break;
        }
    }

    private start(): void {
        this.indexArray = [0, 0, 0, 0, 0, 0];
        for (let i: number = 0; i < 6; i++) {
            let delay: number = 0;

            if (i < 3) {
                delay = 0;
            } else if (i >= 3 && i < 5) {
                delay = 5;
            } else if (i === 5) {
                delay = 10;
            }

            if (this.childs["X" + i] != null) {
                Tweens.removeTweens(this.childs["X" + i], "all");
                Tweens.alphaTween(this.childs["X" + i], {
                    alphas: [0, 1],
                    tweenDuration: 10,
                    tweenDelay: delay,
                });
            }
            if (this.childs["C" + i] != null) {
                this.childs["C" + i].alpha = 0;
            }
        }

        this._timerStatus = 1;
        this._timer.start(25);
    }

    private wawe1(): void {
        for (let i: number = 0; i < 6; i++) {
            let delay: number = i * 5;
            if (this.childs["X" + i] != null) {
                let scalePoints: Array<PIXI.Point> = [];
                scalePoints.push(new PIXI.Point(this.childs["X" + i].scale.x, this.childs["X" + i].scale.y));
                scalePoints.push(
                    new PIXI.Point(this.childs["X" + i].scale.x + 0.1, this.childs["X" + i].scale.y + 0.1),
                );
                scalePoints.push(new PIXI.Point(this.childs["X" + i].scale.x, this.childs["X" + i].scale.y));
                Tweens.removeTweens(this.childs["X" + i], "all");
                Tweens.scaleTween(this.childs["X" + i], {
                    tweenValues: scalePoints,
                    tweenDuration: 30,
                    tweenDelay: delay,
                    tweenEase: "backOut",
                });
            }
        }

        this._timerStatus = 2;
        this._timer.start(75);
    }

    private wawe2(): void {
        for (let i: number = 0; i < 6; i++) {
            let delay: number = i * 5;
            if (this.childs["X" + i] != null) {
                let scalePoints: Array<PIXI.Point> = [];
                scalePoints.push(new PIXI.Point(this.childs["X" + i].scale.x, this.childs["X" + i].scale.y));
                scalePoints.push(
                    new PIXI.Point(this.childs["X" + i].scale.x + 0.1, this.childs["X" + i].scale.y + 0.1),
                );
                scalePoints.push(new PIXI.Point(this.childs["X" + i].scale.x, this.childs["X" + i].scale.y));
                Tweens.removeTweens(this.childs["X" + i], "all");
                Tweens.scaleTween(this.childs["X" + i], {
                    tweenValues: scalePoints,
                    tweenDuration: 30,
                    tweenDelay: delay,
                    tweenEase: "backOut",
                });
            }
        }

        this._timerStatus = 3;
        this._timer.start(75);
    }

    private wawe3(): void {
        let found: boolean = false;
        let indexesCount: number = 0;
        while (!found) {
            let randomIndex: number = parseInt(this.getRandom(0, 6).toString());
            if (randomIndex !== Mystery.MultiplierIndex && this.indexArray[randomIndex] === 0) {
                this.indexArray[randomIndex] = 1;
                indexesCount++;
            }
            if (indexesCount === 2) {
                found = true;
            }
        }

        for (let i: number = 0; i < 6; i++) {
            let delay: number = i * 5;

            if (this.childs["X" + i] != null) {
                let scalePoints: Array<PIXI.Point> = [];
                scalePoints.push(new PIXI.Point(this.childs["X" + i].scale.x, this.childs["X" + i].scale.y));
                scalePoints.push(
                    new PIXI.Point(this.childs["X" + i].scale.x + 0.1, this.childs["X" + i].scale.y + 0.1),
                );
                scalePoints.push(new PIXI.Point(this.childs["X" + i].scale.x, this.childs["X" + i].scale.y));
                Tweens.removeTweens(this.childs["X" + i], "all");
                Tweens.scaleTween(this.childs["X" + i], {
                    tweenValues: scalePoints,
                    tweenDuration: 30,
                    tweenDelay: delay,
                    tweenEase: "backOut",
                });
            }

            if (this.indexArray[i] === 1) {
                if (this.childs["C" + i] != null) {
                    if (this.childs["X" + i] != null) {
                        Tweens.alphaTween(this.childs["X" + i], {
                            alphas: [1, 0.4],
                            tweenDuration: 10,
                            tweenDelay: delay + 15,
                        });
                    }
                    let scalePoints: Array<PIXI.Point> = [];
                    scalePoints.push(
                        new PIXI.Point(this.childs["C" + i].scale.x + 2, this.childs["C" + i].scale.y + 2),
                    );
                    scalePoints.push(new PIXI.Point(this.childs["C" + i].scale.x, this.childs["C" + i].scale.y));
                    this.childs["C" + i].scale.x += 2;
                    this.childs["C" + i].scale.y += 2;
                    Tweens.removeTweens(this.childs["C" + i], "all");
                    Tweens.scaleTween(this.childs["C" + i], {
                        tweenValues: scalePoints,
                        tweenDuration: 30,
                        tweenDelay: delay,
                        tweenEase: "backOut",
                    });
                    Tweens.alphaTween(this.childs["C" + i], {
                        alphas: [0, 1],
                        tweenDuration: 5,
                        tweenDelay: delay,
                    });
                }
            }
        }

        this._timerStatus = 4;
        this._timer.start(75);
    }

    private wawe4(): void {
        let found: boolean = false;
        let indexesCount: number = 0;
        while (!found) {
            let randomIndex: number = parseInt(this.getRandom(0, 6).toString());
            if (randomIndex !== Mystery.MultiplierIndex && this.indexArray[randomIndex] === 0) {
                this.indexArray[randomIndex] = 2;
                indexesCount++;
            }
            if (indexesCount === 2) {
                found = true;
            }
        }

        for (let i: number = 0; i < 6; i++) {
            let delay: number = i * 5;
            if (this.childs["C" + i].alpha === 0) {
                if (this.childs["X" + i] != null) {
                    let scalePoints: Array<PIXI.Point> = [];
                    scalePoints.push(new PIXI.Point(this.childs["X" + i].scale.x, this.childs["X" + i].scale.y));
                    scalePoints.push(
                        new PIXI.Point(this.childs["X" + i].scale.x + 0.1, this.childs["X" + i].scale.y + 0.1),
                    );
                    scalePoints.push(new PIXI.Point(this.childs["X" + i].scale.x, this.childs["X" + i].scale.y));
                    Tweens.removeTweens(this.childs["X" + i], "all");
                    Tweens.scaleTween(this.childs["X" + i], {
                        tweenValues: scalePoints,
                        tweenDuration: 30,
                        tweenDelay: delay,
                        tweenEase: "backOut",
                    });
                }

                if (this.indexArray[i] === 2) {
                    if (this.childs["C" + i] != null) {
                        if (this.childs["X" + i] != null) {
                            Tweens.alphaTween(this.childs["X" + i], {
                                alphas: [1, 0.4],
                                tweenDuration: 10,
                                tweenDelay: delay + 15,
                            });
                        }
                        let scalePoints: Array<PIXI.Point> = [];
                        scalePoints.push(
                            new PIXI.Point(this.childs["C" + i].scale.x + 2, this.childs["C" + i].scale.y + 2),
                        );
                        scalePoints.push(new PIXI.Point(this.childs["C" + i].scale.x, this.childs["C" + i].scale.y));
                        this.childs["C" + i].scale.x += 2;
                        this.childs["C" + i].scale.y += 2;
                        Tweens.removeTweens(this.childs["C" + i], "all");
                        Tweens.scaleTween(this.childs["C" + i], {
                            tweenValues: scalePoints,
                            tweenDuration: 30,
                            tweenDelay: delay,
                            tweenEase: "backOut",
                        });
                        Tweens.alphaTween(this.childs["C" + i], {
                            alphas: [0, 1],
                            tweenDuration: 5,
                            tweenDelay: delay,
                        });
                    }
                }
            }
        }

        this._timerStatus = 5;
        this._timer.start(75);
    }

    private wawe5(): void {
        let found: boolean = false;
        let indexesCount: number = 0;
        while (!found) {
            let randomIndex: number = parseInt(this.getRandom(0, 6).toString());
            if (randomIndex !== Mystery.MultiplierIndex && this.indexArray[randomIndex] === 0) {
                this.indexArray[randomIndex] = 3;
                indexesCount++;
            }
            if (indexesCount === 1) {
                found = true;
            }
        }

        for (let i: number = 0; i < 6; i++) {
            let delay: number = i * 5;
            if (this.childs["C" + i].alpha === 0) {
                if (this.childs["X" + i] != null) {
                    let scalePoints: Array<PIXI.Point> = [];
                    scalePoints.push(new PIXI.Point(this.childs["X" + i].scale.x, this.childs["X" + i].scale.y));
                    scalePoints.push(
                        new PIXI.Point(this.childs["X" + i].scale.x + 0.1, this.childs["X" + i].scale.y + 0.1),
                    );
                    scalePoints.push(new PIXI.Point(this.childs["X" + i].scale.x, this.childs["X" + i].scale.y));
                    Tweens.removeTweens(this.childs["X" + i], "all");
                    Tweens.scaleTween(this.childs["X" + i], {
                        tweenValues: scalePoints,
                        tweenDuration: 30,
                        tweenDelay: delay,
                        tweenEase: "backOut",
                    });
                }

                if (this.indexArray[i] === 3) {
                    if (this.childs["C" + i] != null) {
                        if (this.childs["X" + i] != null) {
                            Tweens.alphaTween(this.childs["X" + i], {
                                alphas: [1, 0.4],
                                tweenDuration: 10,
                                tweenDelay: delay + 15,
                            });
                        }
                        let scalePoints: Array<PIXI.Point> = [];
                        scalePoints.push(
                            new PIXI.Point(this.childs["C" + i].scale.x + 2, this.childs["C" + i].scale.y + 2),
                        );
                        scalePoints.push(new PIXI.Point(this.childs["C" + i].scale.x, this.childs["C" + i].scale.y));
                        this.childs["C" + i].scale.x += 2;
                        this.childs["C" + i].scale.y += 2;
                        Tweens.removeTweens(this.childs["C" + i], "all");
                        Tweens.scaleTween(this.childs["C" + i], {
                            tweenValues: scalePoints,
                            tweenDuration: 30,
                            tweenDelay: delay,
                            tweenEase: "backOut",
                        });
                        Tweens.alphaTween(this.childs["C" + i], {
                            alphas: [0, 1],
                            tweenDuration: 10,
                            tweenDelay: delay,
                        });
                    }
                }
            }
        }

        this._timerStatus = 6;
        this._timer.start(75);
    }

    private final(): void {
        if (this.childs["X" + Mystery.MultiplierIndex] != null) {
            let scalePoints: Array<PIXI.Point> = [];
            scalePoints.push(
                new PIXI.Point(
                    this.childs["X" + Mystery.MultiplierIndex].scale.x,
                    this.childs["X" + Mystery.MultiplierIndex].scale.y,
                ),
            );
            scalePoints.push(
                new PIXI.Point(
                    this.childs["X" + Mystery.MultiplierIndex].scale.x + 0.2,
                    this.childs["X" + Mystery.MultiplierIndex].scale.y + 0.2,
                ),
            );
            scalePoints.push(
                new PIXI.Point(
                    this.childs["X" + Mystery.MultiplierIndex].scale.x,
                    this.childs["X" + Mystery.MultiplierIndex].scale.y,
                ),
            );
            scalePoints.push(
                new PIXI.Point(
                    this.childs["X" + Mystery.MultiplierIndex].scale.x + 0.2,
                    this.childs["X" + Mystery.MultiplierIndex].scale.y + 0.2,
                ),
            );
            scalePoints.push(
                new PIXI.Point(
                    this.childs["X" + Mystery.MultiplierIndex].scale.x,
                    this.childs["X" + Mystery.MultiplierIndex].scale.y,
                ),
            );
            scalePoints.push(
                new PIXI.Point(
                    this.childs["X" + Mystery.MultiplierIndex].scale.x + 0.2,
                    this.childs["X" + Mystery.MultiplierIndex].scale.y + 0.2,
                ),
            );
            scalePoints.push(
                new PIXI.Point(
                    this.childs["X" + Mystery.MultiplierIndex].scale.x,
                    this.childs["X" + Mystery.MultiplierIndex].scale.y,
                ),
            );
            Tweens.removeTweens(this.childs["X" + Mystery.MultiplierIndex], "all");
            Tweens.scaleTween(this.childs["X" + Mystery.MultiplierIndex], {
                tweenValues: scalePoints,
                tweenDuration: 60,
                tweenEase: "backOut",
            });
        }
    }

    private restart(): void {
        for (let i: number = 0; i < 6; i++) {
            if (this.childs["X" + i] != null) {
                this.childs["X" + i].alpha = 0;
            }
            if (this.childs["C" + i] != null) {
                this.childs["C" + i].alpha = 0;
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Mystery.ts
 **/